import type { DeparturesSearchRequest } from '@/features/departures/models';
import type { TripSearchRequest } from '@/features/trips/models/TripSearchRequest';
import type { GetTripResponseDto, PlaceAutocompleteModelDto, SaveTripPatternRequestDto, StopPlaceDto } from '@/types/webapi';
import type ServiceOptions from './ServiceOptions';

export const ISearchServiceId = Symbol.for('ISearchService');

export interface ISearchService {
    searchForTrips(
        request: TripSearchRequest & { fromPlace: PlaceAutocompleteModelDto | null; toPlace: PlaceAutocompleteModelDto | null },
        options?: ServiceOptions
    ): Promise<GetTripResponseDto | null>;

    searchForMoreTrips(
        request: TripSearchRequest & { fromPlace: PlaceAutocompleteModelDto | null; toPlace: PlaceAutocompleteModelDto | null },
        options?: ServiceOptions
    ): Promise<GetTripResponseDto | null>;

    searchForDepartures(
        request: DeparturesSearchRequest & { fromPlace: PlaceAutocompleteModelDto | null },
        options?: ServiceOptions
    ): Promise<StopPlaceDto | null>;

    /**
     * Fetches a trip by trip pattern id. Used for loading shared Trip.
     * @param tripPatternId - The id of the trip pattern to get
     * @param options - The options for the request
     * @returns The trip
     */
    getTripByTripPatternId(tripPatternId: string, options?: ServiceOptions): Promise<GetTripResponseDto | null>;

    /**
     * Saves a trip pattern by id.
     * @param request - The request to save the trip pattern
     * @param options - The options for the request
     */
    saveTripPattern(request: SaveTripPatternRequestDto, options?: ServiceOptions): Promise<void>;
}
